import {Box, Stack} from "@mui/material";
import SocialMediaButtons from "./components/SocialMediaButtons";
import InnField from "./components/InnField";
import FooterData from "./components/FooterData";
import ContactCard from "./components/ContactCard";
import MainLogo from "components/MainLogo";

const DesktopFooter = () => {
  return (
    <Box display={'flex'} flexDirection={'row'} sx={{width:'100%'}} justifyContent={'space-between'}>
      <Box display={'flex'} flexDirection={'row'}>
        <MainLogo iconProps={{sx: {color: 'primary.main', width: 62, height: 115, mr: 6}}}/>
        <Box display={'flex'} flexDirection={'column'}>
          <Stack>
            <SocialMediaButtons/>
            <InnField/>
          </Stack>
          <Box flex={1}/>
          <Stack direction={'row'} spacing={3}>
            <FooterData/>
          </Stack>
        </Box>
      </Box>
      <ContactCard/>
    </Box>
  )
}

export default DesktopFooter
